import React from "react";
import { categorizeGeneralSettings, parseLabel } from "./constants";
import { getChangedSettingsForComponent } from "./utils";
import SettingInput from "./SettingInput";

const GeneralSettings = ({
  tempSettings,
  deviceSettings,
  selectedDevice,
  updateDeviceSettingIsLoading,
  hasChanges,
  handleSettingChange,
  handleCancelChanges,
  handleSaveChanges,
  isDrawer = false,
  readOnly = false,
}) => {
  if (!tempSettings) return null;

  const changedSettings = getChangedSettingsForComponent(
    deviceSettings,
    tempSettings
  );

  const categories = categorizeGeneralSettings(
    selectedDevice?.deviceInfo?.deviceName || selectedDevice?.deviceName
  );

  const hasAnySettingToShow = Object.values(categories).some((category) =>
    category.settings.some((key) => tempSettings[key])
  );
  if (readOnly && !hasAnySettingToShow) {
    return (
      <div className="overflow-y-auto px-3 sm:px-1 mt-2 flex items-center justify-center min-h-[120px] text-gray-500 text-sm">
        Veritabanında bu cihaz için kayıtlı son ayar bulunamadı. Cihaz bir kez bağlandığında ayarlar burada gösterilecektir.
      </div>
    );
  }

  const categoryThemes = [
    {
      border: "border-indigo-100",
      header: "from-white to-indigo-50",
      icon: "bg-indigo-100 text-indigo-600",
      shadow: "shadow-indigo-100",
      divider: "border-indigo-50",
    },
    {
      border: "border-emerald-100",
      header: "from-white to-emerald-50",
      icon: "bg-emerald-100 text-emerald-600",
      shadow: "shadow-emerald-100",
      divider: "border-emerald-50",
    },
    {
      border: "border-amber-100",
      header: "from-white to-amber-50",
      icon: "bg-amber-100 text-amber-600",
      shadow: "shadow-amber-100",
      divider: "border-amber-50",
    },
  ];

  return (
    <>
      <div className="overflow-y-auto px-3 sm:px-1 mt-2">
        <div
          className={`grid grid-cols-1 gap-4 pb-6 ${updateDeviceSettingIsLoading || readOnly ? "opacity-50 pointer-events-none" : ""
            } ${isDrawer ? "md:grid-cols-2" : "md:grid-cols-2 xl:grid-cols-3"}`}
        >
          {Object.entries(categories).map(([categoryKey, category], index) => {
            const relevantSettings = category.settings
              .map((settingKey) => {
                if (tempSettings[settingKey]) {
                  return {
                    ...tempSettings[settingKey],
                    key: settingKey,
                  };
                }
                return null;
              })
              .filter(Boolean);
            if (relevantSettings.length === 0) return null;

            const theme = categoryThemes[index % categoryThemes.length];

            return (
              <div
                key={categoryKey}
                className="overflow-hidden rounded-xl border border-gray-200 bg-white min-w-0"
              >
                <div className="flex items-center gap-2 px-3 py-2 border-b border-gray-100 bg-gray-50/60 min-w-0">
                  <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-md ${theme.icon}`}>
                    <category.icon className="h-3 w-3" />
                  </div>
                  <span className="text-xs font-semibold text-gray-600 truncate">
                    {category.title}
                  </span>
                </div>
                <div className="p-3 pt-4 sm:p-4 sm:pt-5 min-w-0">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-3">
                    {relevantSettings.map((setting) => (
                      <SettingInput
                        key={setting.key}
                        setting={{
                          ...setting,
                          label: parseLabel(setting.label),
                        }}
                        onChange={(value) =>
                          handleSettingChange(setting.key, value)
                        }
                        isChanged={!!changedSettings[setting.key]}
                        originalValue={changedSettings[setting.key]?.original}
                        disabled={readOnly}
                      />
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default GeneralSettings;
